<template>
  <header class="header-container" @click="redirigirFormulario">
    <h1 class="header-title ms-4">MARIDADOR</h1>
    <img src="../assets/logo.png" alt="Logo Kroon" class="header-logo" />
  </header>
</template>

<script>
export default {
  methods: {
    redirigirFormulario() {
      this.$router.push({ name: 'formulario' });  // Redirige al formulario al hacer clic en el header
    }
  },  
  props: {
    showButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: 'Selecciona tu queso',
    },
    onButtonClick: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.header-container {
  position: relative;
  background-color: transparent; /* Fondo principal negro */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px;
}

/* Pseudo-elemento para la franja café claro */
.header-container::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 60px; /* Altura de la franja */
  background-color: #d2b48c;
  transform: translateY(-50%);
  z-index: 1;
}

.header-title {
  position: relative;
  z-index: 2;
  margin: 0;
  line-height: 60px; /* Centrado vertical en la franja */
  font-size: 1.7em;
}

.header-logo {
  position: relative;
  z-index: 2;
  width: 100px;
  /* Se sobrepone la imagen para que sus extremos lleguen más allá de la franja */
  margin-top: -10px;
  margin-bottom: -10px;
}
</style>